/**
 * Ephemeral slice propagating an itinerary whose offer was refreshed outside
 * the itinerary planner (e.g. by the ticket purchase wizard after
 * `OFFER_EXPIRED` / `OFFER_PRICE_CHANGED`) back to the planner list.
 */

import type { ItineraryDTO } from "../../../types/dtos/api/itinerary/itinerary.dto";
import { defineEphemeralSlice } from "../runtime/defineEphemeralSlice";

/**
 * Last externally refreshed itinerary.
 */
export interface ItineraryOfferRefreshState {

    /** Itinerary returned by `POST /api/sales/offer`, `null` before any refresh. */
    "itinerary": ItineraryDTO | null;

    /** Incremented on every refresh so subscribers react even when the same itinerary is refreshed twice. */
    "revision": number;
}

/** Default state: nothing refreshed yet. */
export const ITINERARY_OFFER_REFRESH_DEFAULT: ItineraryOfferRefreshState = {
    "itinerary": null,
    "revision":  0,
};

/**
 * Slice written by the ticket purchase wizard and merged by the itinerary
 * list data flow (`useItineraryListDataFlow`) into its itineraries and
 * selected itinerary (matched by `id`).
 */
export const itineraryOfferRefreshSlice = defineEphemeralSlice<ItineraryOfferRefreshState>( {
    "key":     "itineraryOfferRefresh",
    "default": () => ITINERARY_OFFER_REFRESH_DEFAULT,
} );
